import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import formatDate from "./formatDate";

const byNewest = (a, b) => new Date(b.date) - new Date(a.date);

const NoticePanel = () => {
	const [notices, setNotices] = useState([]);
	const [news, setNews] = useState([]);

	useEffect(() => {
		fetch("/api/notices/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) setNotices([...data].sort(byNewest));
			})
			.catch((error) => console.log(error));
		fetch("/api/events/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) setNews([...data].sort(byNewest));
			})
			.catch((error) => console.log(error));
	}, []);

	return (
		<aside className='panel' aria-label='Notices and news'>
			<div className='panel-head'>Important Notices</div>
			<div className='panel-body'>
				{notices.length === 0 && news.length === 0 && (
					<p className='empty'>No notices at the moment.</p>
				)}
				{notices.slice(0, 5).map((notice) => (
					<div className='list-item' key={`n${notice.id}`}>
						<a href={notice.file} target='_blank' rel='noopener noreferrer'>
							{notice.title}
						</a>
						<small>{formatDate(notice.date)}</small>
					</div>
				))}
				{news.slice(0, 3).map((item) => (
					<div className='list-item' key={`e${item.id}`}>
						{item.outside_url ? (
							<a href={item.outside_url} target='_blank' rel='noopener noreferrer'>
								{item.title}
							</a>
						) : (
							<Link to={`/singleevent/${item.id}`}>{item.title}</Link>
						)}
						<small>News · {formatDate(item.date)}</small>
					</div>
				))}
			</div>
			<div className='panel-foot'>
				<Link to='/notices'>All notices</Link> · <Link to='/events'>All news</Link>
			</div>
		</aside>
	);
};

export default NoticePanel;
